<template>
    <div class="loader"><i class="fa fa-circle-notch fa-spin"></i></div>
</template>

<script>
    export default {
        name: "loading"
    }
</script>

<style scoped>
    .loader{
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #2f2f2f;
        z-index: 888;
        opacity: 0.8;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 3em;
        color: #969696;
    }
</style>